import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Particle from "../Particle";
import Projects from './../Projects/Projects'
import {Button} from "react-bootstrap";
import AboutCard from "../About/AboutCard";
import ReactGA from 'react-ga';
import useAnalyticsEventTracker from "../useAnalyticsEventTracker ";
function Home() {
  const TRACKING_ID = "UA-152844494-2"; // OUR_TRACKING_ID
  ReactGA.initialize(TRACKING_ID);
  
  const gaEventTracker = useAnalyticsEventTracker('Home');
  return (
    <section>
      
      <Container fluid className="home-section" id="home" >
        <Particle />
        <Container className="home-content" >
        <AboutCard />
        </Container>
                     
           
      </Container>
      <Link to="/services" style={{textDecoration: 'none',color: '#ffffff', paddingBottom:'15px'}} >  
      <button class="button-85" role="button" onClick={()=>gaEventTracker('call')}> <h3>Get Started</h3></button>
      </Link>
 <h1></h1>
      <Projects />
    </section>
  );
}

export default Home;
